<xng-breadcrumb class="breadcrumb">
    <ng-container *xngBreadcrumbItem="let breadcrumb">
        <ng-container>{{ breadcrumb }}</ng-container>
    </ng-container>
</xng-breadcrumb>